import React, { useEffect, useState } from "react";
import Header from "../../../../Layout/Header/Header";
import Footer from "../../../../Layout/Footer/Footer";
import Icons from "../../../../../../Config/Images";
import { useDispatch } from "react-redux";
import { getRewardPointUnitsAPI } from "../../../../../../Store/Action/rewardPointsAction";
import "./RewardPointTickets.css";
import { useNavigate } from "react-router-dom";

const RewardPointTickets = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [unitCards, setUnitCards] = useState([]);

  useEffect(() => {
    dispatch(
      getRewardPointUnitsAPI({}, (result) => {
        setUnitCards(result?.data || []);
      })
    );
  }, [dispatch]);

  const handleRewardTicketClick = (unit) => {

    navigate("/my-account/reward-points", {
      state: {
        rewardPointUnitId: Number(unitCards?.[0]?.reward_point_unit_id),
      },
    });
  };

//   const mockRewardUnits = [
//     {
//       reward_point_unit_id: 1,
//       reward_point_percentage: "100.00",
//       progress_status: "completed",
//     },
//     {
//       reward_point_unit_id: 2,
//       reward_point_percentage: "100.00",
//       progress_status: "completed",
//     },
//     {
//       reward_point_unit_id: 3,
//       reward_point_percentage: "100.00",
//       progress_status: "completed",
//     },
//     {
//       reward_point_unit_id: 4,
//       reward_point_percentage: "100.00",
//       progress_status: "completed",
//     },
//     {
//       reward_point_unit_id: 5,
//       reward_point_percentage: "100.00",
//       progress_status: "completed",
//     },
//     {
//       reward_point_unit_id: 6,
//       reward_point_percentage: "37.50",
//       progress_status: "pending", // 🔥 current active ticket
//     },
//   ];

  return (
    <>
      <Header />

      <div className="reward-tickets-wrapper">
        <h2 className="reward-tickets-title">My Reward Tickets</h2>

        <div className="reward-tickets-grid">
          {unitCards.length === 0 ? (
            <p className="no-tickets">No Reward Tickets Available.</p>
          ) : (
            unitCards.map((unit) => (
              <div
                key={unit.reward_point_unit_id}
                onClick={() => handleRewardTicketClick(unit)}
                className={`reward-ticket-card ${
                  unit.progress_status === "completed" ? "completed" : "pending"
                }`}
              >
                <div className="ticket-header">
                  <img
                    src={Icons.reward_point_image}
                    alt="Reward Ticket"
                    className="ticket-icon"
                  />
                  <h3>Reward Ticket #{unit.reward_point_unit_id}</h3>
                </div>

                <div className="ticket-body">
                  <p className="percentage">
                    <span>{unit.reward_point_percentage}%</span> Completed
                  </p>
                  <div className="progress-bar">
                    <div
                      className="progress-fill"
                      style={{
                        width: `${Number(unit.reward_point_percentage)}%`,
                      }}
                    ></div>
                  </div>
                </div>

                <div className="ticket-footer">
                  <span
                    className={`status-badge ${
                      unit.progress_status === "completed"
                        ? "badge-completed"
                        : "badge-pending"
                    }`}
                  >
                    {unit.progress_status}
                  </span>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default RewardPointTickets;
